export const SET_DATA_FOR_EXPORT = 'SET_DATA_FOR_EXPORT';
export const CLEAR_EXPORT_DATA = 'CLEAR_EXPORT_DATA';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const SET_DATE_RANGE_VALIDATION_MESSAGE = 'SET_DATE_RANGE_VALIDATION_MESSAGE';
export const ADD_SELECTED_FILTER = 'ADD_SELECTED_FILTER';
export const REMOVE_SELECTED_FILTER = 'REMOVE_SELECTED_FILTER';
export const ADD_SELECTED_CARRIER = 'ADD_SELECTED_CARRIER';
export const REMOVE_SELECTED_CARRIER = 'REMOVE_SELECTED_CARRIER';
export const SET_SELECTED_PROMISED_DATE = 'SET_SELECTED_PROMISED_DATE';
export const SET_DATA_TABLES = 'SET_DATA_TABLES';
export const SET_LOADING = 'SET_LOADING';
export const DATA_LOADED = 'DATA_LOADED';

export function statsByFilterReducer(state, action) {
  switch (action.type) {
    case SET_DATA_FOR_EXPORT:
      return {
        ...state,
        dataForExport: [...state.dataForExport, ...action.dataForExport],
        tableDataReturnedCount: state.tableDataReturnedCount + 1,
      };
    case CLEAR_EXPORT_DATA:
      return {
        ...state,
        dataForExport: [],
        tableDataReturnedCount: 0,
      };
    case SET_START_DATE:
      return {
        ...state,
        startDate: action.startDate,
        dateRangeValidationMessage: null,
      };
    case SET_END_DATE:
      return {
        ...state,
        endDate: action.endDate,
        dateRangeValidationMessage: null,
      };
    case SET_DATE_RANGE_VALIDATION_MESSAGE:
      return {
        ...state,
        dateRangeValidationMessage: action.dateRangeValidationMessage,
      };
    case ADD_SELECTED_FILTER:
      return {
        ...state,
        selectedFilters: [...state.selectedFilters, action.newlySelectedFilter],
      };
    case REMOVE_SELECTED_FILTER:
      return {
        ...state,
        selectedFilters: state.selectedFilters.filter(f => f !== action.filterToRemove),
      };
    case ADD_SELECTED_CARRIER:
      return {
        ...state,
        selectedCarriers: [...state.selectedCarriers, action.newlySelectedCarrier],
      };
    case REMOVE_SELECTED_CARRIER:
      return {
        ...state,
        selectedCarriers: state.selectedCarriers.filter(c => c !== action.carrierToRemove),
      };
    case SET_DATA_TABLES:
      return {
        ...state,
        dataTables: action.dataTables,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    case DATA_LOADED:
      return {
        ...state,
        shipmentEventFilters: action.shipmentEventFilters,
        carriers: action.carriers,
        loading: false,
      };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}

export const SET_TABLE_DATA = 'SET_TABLE_DATA';
export const SET_TABLE_FAILED_MESSAGE = 'SET_TABLE_FAILED_MESSAGE';
export const SET_TABLE_LOADING = 'SET_TABLE_LOADING';

export function statsByFilterTableReducer(state, action) {
  switch (action.type) {
    case SET_TABLE_DATA:
      return { data: action.data, failedMessage: '', loading: false };
    case SET_TABLE_FAILED_MESSAGE:
      return { data: { stats_rows: [] }, failedMessage: action.failedMessage, loading: false };
    case SET_TABLE_LOADING:
      return { data: null, failedMessage: '', loading: true };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
